"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { MenuDesktopItem } from "./MenuDesktopItem";
import type { HeaderData } from "../types";
import { cn } from "@local/utils/src/cn";
interface Props {
  data: HeaderData | null;
  market: string;
  className?: string;
}
export const HeaderMenuDesktop = t0 => {
  const $ = _c(11);
  const {
    data,
    market,
    className
  } = t0;
  const [activeIndex, setActiveIndex] = useState(null);
  let t1;
  if ($[0] !== className) {
    t1 = cn("ml-4 hidden h-full flex-row items-center gap-8 align-middle text-sm xl:visible xl:flex", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeIndex || $[3] !== data?.navigationMain || $[4] !== market) {
    t2 = data?.navigationMain?.map((item, i) => <MenuDesktopItem key={`menu-item-desktop-${item.id}-${i}`} item={item} id={`menu-item-desktop-client-${i}`} market={market} open={activeIndex === i} onOpen={() => setActiveIndex(i)} onClose={() => setActiveIndex(prev => prev === i ? null : prev)} />);
    $[2] = activeIndex;
    $[3] = data?.navigationMain;
    $[4] = market;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ul className="contents list-none">{t2}</ul>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <nav aria-label="Main navigation" className={t1}>{t3}</nav>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};